export const QMS_USER_STORAGE_KEY = 'qms-user-data';
export const QMS_MOBILE_STORAGE_KEY = 'qms-mobile-number';

function firstFilled(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const value = values[i];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return String(value).trim();
    }
  }
  return '';
}

function getUserSource(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  if (payload.data && typeof payload.data === 'object') {
    return payload.data;
  }
  return payload;
}

export function normalizeQmsUser(payload) {
  const source = getUserSource(payload);
  if (!source || typeof source !== 'object') {
    return null;
  }

  if (!Object.keys(source).length) {
    return null;
  }

  // eslint-disable-next-line no-underscore-dangle
  const legacyId = source._id;

  return {
    id: firstFilled(source.id, legacyId),
    employeeCode: firstFilled(source.employeeCode, source.employee_code, source.empCode, source.emp_code),
    employeeName: firstFilled(source.employeeName, source.employee_name, source.name),
    storeCode: firstFilled(source.storeCode, source.store_code, source.storeId, source.storeID, source.storeid),
    employeeMobile: firstFilled(source.employeeMobile, source.employee_mobile, source.mobile, source.phone, source.id),
    department: firstFilled(source.department, source.dept)
  };
}

export function hasQmsUserData(payload) {
  const user = normalizeQmsUser(payload);
  if (!user) {
    return false;
  }

  return [user.id, user.employeeCode, user.employeeName, user.storeCode, user.employeeMobile, user.department].some(
    value => value !== ''
  );
}

export function readQmsUserFromStorage() {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    const raw = localStorage.getItem(QMS_USER_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return normalizeQmsUser(JSON.parse(raw));
  } catch (_e) {
    return null;
  }
}

export function saveQmsUserToStorage(payload) {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const normalized = normalizeQmsUser(payload);
  if (!normalized) {
    return null;
  }

  localStorage.setItem(QMS_USER_STORAGE_KEY, JSON.stringify(normalized));
  if (normalized.employeeMobile) {
    localStorage.setItem(QMS_MOBILE_STORAGE_KEY, normalized.employeeMobile);
  }
  return normalized;
}

export function clearQmsUserFromStorage() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.removeItem(QMS_USER_STORAGE_KEY);
}
